// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__Z7yy7","content":"LayoutSettings_content__1RNhu"};